export class MicroappUserManListFilter{
    general: string;
    rol: string;
    tenant: string;
    host: string;
}